import { Box, Tab, Tabs } from "@material-ui/core";
import { useState, useEffect } from "react";
import { tabStyles } from "./style";
import Authorize from "../Authorize";
import { isAuthorized } from "../Authorize/authorizeUtil";

function tabProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function TabPanel(props) {
    const { children, value, index, clearOnSwitch = true, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {(value === index || !clearOnSwitch) && (
                <Box>
                    {children}
                </Box>
            )}
        </div>
    );
}

export const TabsWrapper = ({ tabs, selectedTab = 0, setSelectedTab, className, selectByTabKey }) => {
    const classes = tabStyles();
    const filteredTabs = tabs?.filter(tab => !tab.permission || isAuthorized(tab.permission)) || [];
    const [value, setValue] = useState(selectedTab ?? selectByTabKey ? filteredTabs?.[0]?.key : 0);

    useEffect(() => {
        if (filteredTabs.length > 0 && value >= filteredTabs.length) {
            setValue(selectByTabKey ? filteredTabs?.[0]?.key : 0); // Reset to first tab if current value is out of range
        }
    }, [filteredTabs.length]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
        setSelectedTab && setSelectedTab(newValue);
    };

    useEffect(() => {
        setValue(selectedTab);
    }, [selectedTab]);

    return (
        <>
            <Box className={`${classes.tabsWrapper} ${className}`}>
                <Tabs value={value} onChange={handleChange} centered>
                    {filteredTabs.map((tab, index) => (
                        <Tab {...tabProps(index)} key={`v_tab_${index}`} label={tab.label} value={selectByTabKey ? tab.key : index} icon={tab?.icon} />
                    ))}
                </Tabs>
            </Box>
            <Box>
                {filteredTabs.map((tab, index) => (
                    <div key={index}>
                        {tab.permission ? (
                            tab.component &&
                            <Authorize profile={tab.permission}>
                                <TabPanel value={value} index={index} clearOnSwitch={tab.clearOnSwitch}>
                                    {tab.component}
                                </TabPanel>
                            </Authorize>
                        ) : (
                            tab.component && (
                                <TabPanel value={value} index={index} clearOnSwitch={tab.clearOnSwitch}>
                                    {tab.component}
                                </TabPanel>
                            )
                        )}
                    </div>
                ))}
            </Box>
        </>
    );
};

